<template>
    <a id="back2Top" @click="scrollToTop" class="top-scroll" title="Back to top" :class="scroll ? 'd-flex' : 'd-none'" href="#"><i class="fa-solid fa-arrow-up"></i></a>
</template>

<script setup>

    import { onMounted, ref } from 'vue';

    let scroll = ref(false);
   

    const scrollToTop = () =>{
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleScroll = () => {
        if (window.scrollY >= 50) {
            scroll.value = true
        } else {
            scroll.value = false
        }
    }

    onMounted(()=>{
		window.addEventListener('scroll', handleScroll);
	})
</script>
